import { object, string, ObjectSchema } from 'yup';

export default function makeCarDataValidation(): ObjectSchema {
  const maxCharacterVinNumber = 17;
  const maxCharacterSerialMotor = 17;

  function createMaxRegex(maxCharacter: number): RegExp {
    return new RegExp(`^.{0,${maxCharacter}}$`);
  }

  return object().shape({
    vinNumber: string()
      .nullable()
      .required('El campo de número de chasis es obligatorio')
      .min(10, 'El campo de número de chasis debe tener mínimo 10 caracteres')
      .matches(createMaxRegex(maxCharacterVinNumber), {
        message: `La cantidad de caracteres no puede ser mayor a ${maxCharacterVinNumber}`,
      }),
    licensePlate: string()
      .required('El campo de placa es obligatorio')
      .length(6, 'La cantidad de caracteres debe ser igual a 6'),
    serialMotor: string()
      .nullable()
      .required('El campo de número de motor es obligatorio')
      .matches(createMaxRegex(maxCharacterSerialMotor), {
        message: `La cantidad de caracteres no puede ser mayor a ${maxCharacterSerialMotor}`,
      }),
  });
}
